import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select.tsx'
import { classNames } from '@/utils/helpers.ts'

interface Props<T> {
  sortOption: T
  handleSortChange: (values: T) => void
  sortOptions: Record<string, T>
  className?: string
}
export const SortOptionsSelect = <T extends string>({
  sortOption,
  handleSortChange,
  sortOptions,
  className,
}: Props<T>) => {
  return (
    <Select
      onValueChange={handleSortChange}
      value={sortOption}
    >
      <SelectTrigger
        className={classNames('h-full min-w-36 py-2.5 text-title', className)}
      >
        <SelectValue className="truncate" />
      </SelectTrigger>
      <SelectContent className="max-h-64">
        <SelectGroup className="text-title">
          {Object.entries(sortOptions)?.map(([key, value]) => (
            <SelectItem
              key={key}
              value={value}
            >
              <span className="truncate capitalize">
                {key.replace('_', ' ')}
              </span>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
